import ResultPage from '@/components/Result/index'

const ShareDataSuccessPage = () => {
	const breadcrumbItem = [
		{
			label: '',
			link: `/`,
		},
		{
			label: 'Shared Data',
			link: `/shared-data`
		},
		{
			label: 'Share Data',
			link: `/shared-data/share`
		},
		{
			label: 'Fail',
			link: `/shared-data/share/fail`
		}
	]

	return ResultPage({
		layoutHeaderTxt: "somethingWrong",
		layoutSubHeaderTxt: "somethingWrongSharingMessage",
		defaultTitle: "shareData",
		nextLocation: '/shared-data/share',
		breadcrumbs: breadcrumbItem,
		layoutContentImgPath: "/img/fail.png",
		backBtnTxt: "tryAgain",
	});
}
export default ShareDataSuccessPage
